<template>
    <div :class="{
           '_e-FormChoice--disabled' : disabled
         }" class="_e-FormChoice">
        <FormLabel :item="item"/>
        <div class="_e-FormChoice__btn-group">
            <button :ref="mappingWithLetter(index)"
                    :disabled="disabled"
                    :key="index"
                    :style="cssVar"
                    :class="{
                       '_e-FormChoice__btn-group__button--selected' : choice.value === value.value
                    }"
                    @click="update(choice)"
                    class="_e-FormChoice__btn-group__button"
                    v-for="(choice,index) in choices">
                <span class="_e-FormChoice__btn-group__button__letter">{{mappingWithLetter(index)}}</span>
                {{choice.value}}
            </button>
        </div>
        <FormTextDisabled :disabled="disabled"/>
    </div>
</template>
<script>
  import FormLabel from '@/components/elements/FormLabel';
  import FormTextDisabled from '@/components/elements/FormTextDisabled';

  export default {
    name: 'FormChoice',
    components: {FormTextDisabled, FormLabel},
    data() {
      return {
        keys: [
          'A', 'Z', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'Q', 'S',
          'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'W', 'X', 'C', 'V', 'B', 'N'],
      };
    },
    props: {
      value: {type: [String, Number, Object], default: ''},
      item: {type: [Array, Object], default: () => {}},
      disabled: {type: Boolean, default: true},
      active: {type: Boolean, default: false},
      last: {type: Boolean, default: false},
    },
    mounted() {
      window.addEventListener('keyup', this.handlerChoiceKeyup);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.handlerChoiceKeyup);
    },
    methods: {
      handlerChoiceKeyup($event) {
        if (this.active === true) {
          let index = this.keys.indexOf($event.key.toUpperCase());
          if (index != -1) {
            $event.stopPropagation();
            $event.stopImmediatePropagation();
            let choice = this.choices[index];
            if (choice) {
              this.$emit('input', choice);
            }
          }
        }
      },
      update(value) {
        this.$emit('input', {
          id: this.item.id,
          title: this.item.title,
          value: value.value,
          link: value.link,
        });
      },
      mappingWithLetter(index) {
        return this.keys[index];
      },
    },
    computed: {
      cssVar() {
        return {
          '--width-min': this.maxPixelLength + 'px',
          'width': this.maxPixelLength + 'px',
        };
      },
      maxPixelLength() {
        let maxLetter = 0;
        for (let key in this.choices) {
          let choice = this.choices[key];
          if (choice.value.length > maxLetter) {
            maxLetter = choice.value.length;
          }
        }

        let minpixel = maxLetter * 10 + 25 + 15 + 40;
        if (minpixel < 100) {
          minpixel = 100;
        }
        return minpixel;
      },
      choices() {
        let choices = [];
        if (this.item) {
          for (let choice of this.item.choices) {
            if (choice.value.map) {
              for (let sousValue of choice.value) {
                choices.push({...choice, value: sousValue});
              }
            }
            else {
              choices.push({...choice, value: choice.value});
            }
          }
        }
        return choices;
      },
    },
  };
</script>
<style scoped>
    ._e-FormChoice--disabled ._e-FormChoice__btn-group * {
        opacity: 0.2;
        cursor: not-allowed;
        z-index: 200;
    }

    ._e-FormChoice__btn-group {
        display: inline-flex;

        flex-wrap: wrap;
        flex-direction: row;
        justify-items: flex-start;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
        margin-bottom: 40px;
        width: calc(100% - 3rem);
        margin-left: 3rem;

    }

    ._e-FormChoice__btn-group__button {
        position: relative;
        border: none;
        color: white;
        font-size: 1.2rem;
        line-height: 20px;
        background-color: rgba(255, 255, 255, 0.1);
        box-shadow: rgba(255, 255, 255, 0.8) 0px 0px 0px 2px inset;
        cursor: pointer;
        height: auto;
        opacity: 0.8;
        border-radius: 4px;
        padding: 10px 15px;
        padding-left: 40px;
        text-align: left;
        margin-top: 10px;
        margin-right: 10px;

        white-space: nowrap;
        width: var(--width-min);
        max-width: 100%;
        flex: 0 1 auto;

        overflow: hidden;
        text-overflow: ellipsis;
    }

    ._e-FormChoice__btn-group__button:hover {
        background: rgba(255, 255, 255, 0.3);
        opacity: 1;
    }

    ._e-FormChoice__btn-group__button--selected {
        background: rgba(255, 255, 255, 0.7);
    }

    ._e-FormChoice__btn-group__button__letter {
        position: absolute;
        font-weight: 600;
        top: 10px;
        bottom: 0;
        left: 10px;
        font-size: 0.7rem;
        height: 20px;
        width: 20px;
        border: 1px solid white;
        border-radius: 4px;
        text-align: center;
        line-height: 19px;
    }

</style>